import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { EntityUnionType } from 'common/types/entities/EntityInterface'
import { useMemo } from 'react'
import { MenuInterface } from 'src/shared/types/entities/menu'

const isMenuEntity = (entity: EntityUnionType): entity is MenuInterface =>
  entity.type === EntityTypeEnum.Menu

export const useIsHiddenMenu = (entities: EntityUnionType[]) => {
  return useMemo(() => {
    return entities.some(entity => {
      if (!isMenuEntity(entity)) {
        return false
      }
      return entity.menuItems.length === 0
    })
  }, [entities])
}
